module.exports = __webpack_public_path__ + "static/007-867f44d514ba218855f87706f2aa3a29.jpg";